import CryptoJS from 'crypto-js';

// Function to encrypt the string
export const encryptString = (text) => {
  return CryptoJS.AES.encrypt(text, process.env.REACT_APP_LUCI_KEY).toString();
};